import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Grid,
  Typography,
  Switch,
  FormControlLabel,
  TextField,
  Button,
  Paper,
  CircularProgress,
  Divider,
  Box,
  Snackbar,
  InputAdornment,
  Collapse,
  useMediaQuery,
  useTheme,
  Chip,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import StorefrontIcon from '@material-ui/icons/Storefront';
import SaveIcon from '@material-ui/icons/Save';
import ColorLensIcon from '@material-ui/icons/ColorLens';
import ImageIcon from '@material-ui/icons/Image';
import PhoneIcon from '@material-ui/icons/Phone';
import LinkIcon from '@material-ui/icons/Link';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import EmailIcon from '@material-ui/icons/Email';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ScheduleIcon from '@material-ui/icons/Schedule';
import ShareIcon from '@material-ui/icons/Share';
import LanguageIcon from '@material-ui/icons/Language';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import AssistantIcon from '@material-ui/icons/Assistant';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import InputMask from 'react-input-mask';

import PageContent from '../../../components/Main/Content/mainContent';
import UIContainer from '../../../components/UI/Container/UIContainer';
import UIFormTitle from '../../../components/UI/Form/Title/UIFormTitle';
import UIImageUpload from '../../../components/UI/ImageUpload/UIImageUpload';
import useApi from '../../../utils/useApi';
import StoreContext from '../../../components/Store/context';
import AccessRestricted from '../../../components/Error/AccessRestricted/AccessRestricted';
import { isAdminUser } from '../../../utils/permissionUtils';

const ConfiguracaoCatalogo = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const history = useHistory();
  const { credencials } = useContext(StoreContext);
  const isAdmin = isAdminUser(credencials);

  const [catalogEnabled, setCatalogEnabled] = useState(false);

  const [whatsapp, setWhatsapp] = useState('');
  const [catalogSlug, setCatalogSlug] = useState('');
  const [catalogSubtitle, setCatalogSubtitle] = useState('');
  const [heroSubtitle, setHeroSubtitle] = useState('');
  const [instagram, setInstagram] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [businessHours, setBusinessHours] = useState('');
  const [facebook, setFacebook] = useState('');
  const [tiktok, setTiktok] = useState('');
  const [website, setWebsite] = useState('');

  const [primaryColor, setPrimaryColor] = useState('#2563eb');
  const [secondaryColor, setSecondaryColor] = useState('#3b82f6');
  const [supportColor, setSupportColor] = useState('#10b981');
  const [backgroundColor, setBackgroundColor] = useState('#f8fafc');
  const [cardColor, setCardColor] = useState('#ffffff');
  const [textColor, setTextColor] = useState('#0f172a');
  const [logoUrl, setLogoUrl] = useState('');
  const [bannerUrl, setBannerUrl] = useState('');
  const [companyName, setCompanyName] = useState('Sua Loja');
  const [companyPseudonym, setCompanyPseudonym] = useState('Sua Loja');
  const [companyCNPJ, setCompanyCNPJ] = useState('');

  const [mobilePreviewOpen, setMobilePreviewOpen] = useState(false);
  const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });

  const storeUrl = `https://${catalogSlug || 'sua-loja'}.duzz.store`;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(storeUrl);
    setToast({
      open: true,
      message: 'Link do catálogo copiado para a área de transferência!',
      severity: 'success',
    });
  };

  const handleCopyWhatsAppMsg = () => {
    const message = `Olá! 👋 Acesse o nosso catálogo online e confira nossos produtos e serviços disponíveis:\n\n👉 *${companyPseudonym || 'Nossa Loja'}*\n🔗 ${storeUrl}\n\nAguardamos o seu pedido! 🛒✨`;
    navigator.clipboard.writeText(message);
    setToast({
      open: true,
      message: 'Mensagem formatada para WhatsApp copiada!',
      severity: 'success',
    });
  };

  const THEME_PRESETS = [
    { name: 'Claro Minimalista', bg: '#f8fafc', card: '#ffffff', text: '#0f172a', primary: '#2563eb', secondary: '#3b82f6', support: '#10b981' },
    { name: 'Claro Clean', bg: '#f1f5f9', card: '#ffffff', text: '#1e293b', primary: '#0284c7', secondary: '#38bdf8', support: '#10b981' },
    { name: 'Escuro Padrão', bg: '#090d16', card: '#151d30', text: '#f8fafc', primary: '#5b7cfa', secondary: '#3b82f6', support: '#34d399' },
    { name: 'Oceano Profundo', bg: '#0b132b', card: '#1c2541', text: '#ffffff', primary: '#48cae4', secondary: '#0077b6', support: '#52b788' },
    { name: 'Roxo Noturno', bg: '#0f0c20', card: '#1d1738', text: '#f3f0ff', primary: '#9d4edd', secondary: '#7b2cbf', support: '#ff9e00' },
    { name: 'Amarelo & Ouro', bg: '#12100b', card: '#1f1b12', text: '#fef08a', primary: '#eab308', secondary: '#ca8a04', support: '#facc15' },
    { name: 'Vermelho & Preto', bg: '#0d0405', card: '#1c0a0c', text: '#fecdd3', primary: '#ef4444', secondary: '#b91c1c', support: '#f87171' },
  ];

  const applyPreset = (preset) => {
    setBackgroundColor(preset.bg);
    setCardColor(preset.card);
    setTextColor(preset.text);
    setPrimaryColor(preset.primary);
    setSecondaryColor(preset.secondary);
    setSupportColor(preset.support);
  };

  const isPresetActive = (preset) => {
    return (
      backgroundColor.toLowerCase() === preset.bg.toLowerCase() &&
      cardColor.toLowerCase() === preset.card.toLowerCase() &&
      textColor.toLowerCase() === preset.text.toLowerCase() &&
      primaryColor.toLowerCase() === preset.primary.toLowerCase() &&
      secondaryColor.toLowerCase() === preset.secondary.toLowerCase() &&
      supportColor.toLowerCase() === preset.support.toLowerCase()
    );
  };

  const formatPhoneNumber = (val) => {
    if (!val) return '';
    let clean = String(val).replace(/\D/g, '');
    if (clean.startsWith('55') && (clean.length === 12 || clean.length === 13)) {
      clean = clean.slice(2);
    }
    if (clean.length <= 2) return clean;
    if (clean.length <= 6) return `(${clean.slice(0, 2)}) ${clean.slice(2)}`;
    if (clean.length <= 10) return `(${clean.slice(0, 2)}) ${clean.slice(2, 6)}-${clean.slice(6)}`;
    return `(${clean.slice(0, 2)}) ${clean.slice(2, 7)}-${clean.slice(7, 11)}`;
  };

  const cleanPhoneDigits = (val) => {
    if (!val) return '';
    const clean = String(val).replace(/\D/g, '');
    if (!clean) return '';
    if (clean.length === 10 || clean.length === 11) {
      return `55${clean}`;
    }
    return clean;
  };

  const cleanInstagramHandle = (val) => {
    if (!val) return '';
    let clean = String(val).trim();
    if (clean.includes('instagram.com/')) {
      const match = clean.match(/instagram\.com\/([a-zA-Z0-9._]+)/i);
      clean = match ? match[1] : clean;
    }
    return clean.replace(/^@+/, '');
  };

  const [loadSettings, loadSettingsInfo] = useApi({
    method: 'get',
    url: '/catalog/settings',
  });

  const [saveSettings, saveSettingsInfo] = useApi({
    method: 'put',
    url: '/catalog/settings',
  });

  const [generateBrandPalette, generateBrandPaletteInfo] = useApi({
    method: 'post',
    url: '/duxia/agents/brand-palette',
  });

  const handleSuggestPaletteWithAI = () => {
    if (!logoUrl && !bannerUrl) {
      setToast({
        open: true,
        message: 'Adicione uma logo ou banner primeiro para que a duxIA possa sugerir as cores da sua loja.',
        severity: 'warning',
      });
      return;
    }

    generateBrandPalette({
      data: {
        logo_url: logoUrl,
        banner_url: bannerUrl,
      },
      onCompleted: (res) => {
        if (res && res.data && !res.error) {
          const palette = res.data;
          if (palette.primary_color) setPrimaryColor(palette.primary_color);
          if (palette.secondary_color) setSecondaryColor(palette.secondary_color);
          if (palette.support_color) setSupportColor(palette.support_color);
          if (palette.background_color) setBackgroundColor(palette.background_color);
          if (palette.card_color) setCardColor(palette.card_color);
          if (palette.text_color) setTextColor(palette.text_color);

          setToast({
            open: true,
            message: `✨ Paleta "${palette.theme_name || 'Harmoniosa'}" aplicada pela duxIA! ${palette.explanation || ''}`,
            severity: 'success',
          });
        } else {
          setToast({
            open: true,
            message: res?.error || 'Não foi possível gerar a paleta de cores com a duxIA.',
            severity: 'error',
          });
        }
      },
    });
  };

  useEffect(() => {
    loadSettings({
      onCompleted: (res) => {
        if (res && res.data) {
          const data = res.data;
          setCatalogEnabled(Boolean(data.catalog_enabled));
          setWhatsapp(formatPhoneNumber(data.whatsapp || credencials?.companyData?.whatsapp || ''));
          setCatalogSlug(data.catalog_slug || '');
          setCatalogSubtitle(data.catalog_subtitle || '');
          setHeroSubtitle(data.hero_subtitle || '');
          setInstagram(cleanInstagramHandle(data.instagram || ''));
          setPhone(formatPhoneNumber(data.phone || ''));
          setEmail(data.email || '');
          setAddress(data.address || '');
          setBusinessHours(data.business_hours || '');
          setFacebook(data.facebook || '');
          setTiktok(data.tiktok || '');
          setWebsite(data.website || '');
          setPrimaryColor(data.primary_color || '#5b7cfa');
          setSecondaryColor(data.secondary_color || '#3b82f6');
          setSupportColor(data.support_color || '#34d399');
          setBackgroundColor(data.background_color || '#090d16');
          setCardColor(data.card_color || '#151d30');
          setTextColor(data.text_color || '#f8fafc');
          setLogoUrl(data.logo_url || credencials?.companyData?.logo_url || credencials?.companyData?.logoUrl || '');
          setBannerUrl(data.banner_url || '');
          if (data.name) setCompanyName(data.name);
          setCompanyPseudonym(data.pseudonym || data.name || 'Sua Loja');
          setCompanyCNPJ(data.cnpj || '');
        }
      },
    });
  }, [credencials]);

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    saveSettings({
      data: {
        catalog_enabled: catalogEnabled,
        whatsapp: cleanPhoneDigits(whatsapp),
        catalog_slug: catalogSlug,
        catalog_subtitle: catalogSubtitle,
        hero_subtitle: heroSubtitle,
        instagram: cleanInstagramHandle(instagram),
        phone: phone.trim(),
        email: email.trim(),
        address: address.trim(),
        business_hours: businessHours.trim(),
        facebook: facebook.trim(),
        tiktok: tiktok.trim(),
        website: website.trim(),
        primary_color: primaryColor,
        secondary_color: secondaryColor,
        support_color: supportColor,
        background_color: backgroundColor,
        card_color: cardColor,
        text_color: textColor,
        logo_url: logoUrl,
        banner_url: bannerUrl,
      },
      onCompleted: (res) => {
        if (res && !res.error) {
          setToast({
            open: true,
            message: 'Configurações do catálogo salvas com sucesso!',
            severity: 'success',
          });
        } else {
          setToast({
            open: true,
            message: res?.error || 'Erro ao salvar configurações.',
            severity: 'error',
          });
        }
      },
    });
  };

  const renderSectionHeader = (Icon, title, description) => (
    <Box display="flex" alignItems="center" mb={1.5} style={{ borderLeft: '4px solid #2563eb', paddingLeft: 10, minWidth: 0 }}>
      <Icon style={{ color: '#2563eb', marginRight: 8, fontSize: 22, flexShrink: 0 }} />
      <div style={{ minWidth: 0 }}>
        <Typography variant="subtitle2" style={{ fontWeight: 700, color: '#0f172a', lineHeight: 1.2 }}>
          {title}
        </Typography>
        {description && (
          <Typography variant="caption" style={{ color: '#64748b', display: 'block', fontSize: 11 }}>
            {description}
          </Typography>
        )}
      </div>
    </Box>
  );

  const renderColorPickerItem = (label, color, setColor) => (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p={1.5}
      style={{
        backgroundColor: '#f8fafc',
        borderRadius: 10,
        border: '1px solid #e2e8f0',
      }}
    >
      <Box display="flex" alignItems="center" style={{ gap: 10 }}>
        <input
          type="color"
          value={color}
          onChange={(e) => setColor(e.target.value)}
          style={{
            width: 36,
            height: 36,
            border: '2px solid #cbd5e1',
            borderRadius: 8,
            cursor: 'pointer',
            padding: 0,
            backgroundColor: 'transparent',
          }}
        />
        <div>
          <Typography variant="caption" style={{ fontWeight: 600, display: 'block', color: '#334155' }}>
            {label}
          </Typography>
          <Typography variant="caption" style={{ color: '#94a3b8', fontSize: 11, fontFamily: 'monospace' }}>
            {color.toUpperCase()}
          </Typography>
        </div>
      </Box>
      {isDesktop && (
        <TextField
          variant="outlined"
          size="small"
          value={color}
          onChange={(e) => setColor(e.target.value)}
          style={{ width: 95 }}
          inputProps={{
            style: { fontSize: 12, padding: '6px 8px', fontFamily: 'monospace', textTransform: 'uppercase' },
          }}
        />
      )}
    </Box>
  );

  const renderPreview = () => (
    <Paper
      elevation={3}
      style={{
        padding: 20,
        borderRadius: 16,
        backgroundColor: backgroundColor,
        backgroundImage: `radial-gradient(at 0% 0%, ${primaryColor}25 0px, transparent 70%), radial-gradient(at 100% 100%, ${secondaryColor}20 0px, transparent 70%)`,
        color: textColor,
        border: '1px solid rgba(226, 232, 240, 0.8)',
        boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05)',
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
        <Typography variant="subtitle2" style={{ fontWeight: 700, color: textColor, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: 11 }}>
          ● Pré-visualização ao vivo
        </Typography>
        <span
          style={{
            padding: '4px 12px',
            borderRadius: 20,
            fontSize: 11,
            fontWeight: 700,
            backgroundColor: catalogEnabled ? '#10b98122' : '#ef444422',
            color: catalogEnabled ? '#10b981' : '#f87171',
          }}
        >
          {catalogEnabled ? '● Loja Online' : '● Indisponível'}
        </span>
      </Box>

      {/* Header Simulado */}
      <Box
        p={2}
        style={{
          backgroundColor: cardColor,
          borderRadius: '10px 10px 0 0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: `3px solid ${primaryColor}`,
          boxShadow: '0 2px 4px rgba(0,0,0,0.03)',
        }}
      >
        <Box display="flex" alignItems="center" style={{ gap: 10 }}>
          {logoUrl ? (
            <img
              src={logoUrl}
              alt="Logo"
              style={{ width: 36, height: 36, borderRadius: 8, objectFit: 'cover' }}
            />
          ) : (
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: 8,
                backgroundColor: primaryColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                color: '#fff',
                fontSize: 14,
              }}
            >
              {companyPseudonym.charAt(0).toUpperCase()}
            </div>
          )}
          <div>
            <Typography variant="subtitle2" style={{ fontWeight: 700, color: textColor, lineHeight: 1.1 }}>
              {companyPseudonym}
            </Typography>
            <Typography variant="caption" style={{ color: textColor, opacity: 0.7, fontSize: 10 }}>
              {catalogSubtitle || 'Catálogo Oficial'}
            </Typography>
          </div>
        </Box>
      </Box>

      {/* Banner Simulado */}
      <Box
        p={2.5}
        style={{
          minHeight: 110,
          borderRadius: '0 0 10px 10px',
          backgroundImage: bannerUrl
            ? `linear-gradient(to right, rgba(15,23,42,0.85), rgba(15,23,42,0.4)), url(${bannerUrl})`
            : `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Typography variant="subtitle1" style={{ fontWeight: 800, color: '#fff', textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>
          Bem-vindo à {companyPseudonym}!
        </Typography>
        <Typography variant="caption" style={{ color: 'rgba(255,255,255,0.9)', marginTop: 2 }}>
          {heroSubtitle || 'Explore nossos produtos e faça seu pedido direto pelo WhatsApp.'}
        </Typography>
      </Box>

      {/* Chips Rápidos Sociais / Contatos Simulados */}
      {(instagram || whatsapp || phone || businessHours || address) && (
        <Box mt={1.5} display="flex" flexWrap="wrap" style={{ gap: 6 }}>
          {instagram && (
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
                padding: '4px 10px',
                borderRadius: 20,
                fontSize: 10,
                fontWeight: 600,
                backgroundColor: cardColor,
                color: textColor,
                border: '1px solid rgba(0,0,0,0.08)',
              }}
            >
              📸 {instagram.startsWith('@') ? instagram : `@${instagram}`}
            </span>
          )}
          {whatsapp && (
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
                padding: '4px 10px',
                borderRadius: 20,
                fontSize: 10,
                fontWeight: 600,
                backgroundColor: '#10b98118',
                color: '#10b981',
                border: '1px solid #10b98133',
              }}
            >
              💬 WhatsApp
            </span>
          )}
          {businessHours && (
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
                padding: '4px 10px',
                borderRadius: 20,
                fontSize: 10,
                fontWeight: 600,
                backgroundColor: cardColor,
                color: textColor,
                border: '1px solid rgba(0,0,0,0.08)',
              }}
            >
              🕒 {businessHours}
            </span>
          )}
          {address && (
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
                padding: '4px 10px',
                borderRadius: 20,
                fontSize: 10,
                fontWeight: 600,
                backgroundColor: cardColor,
                color: textColor,
                border: '1px solid rgba(0,0,0,0.08)',
              }}
            >
              📍 {address}
            </span>
          )}
        </Box>
      )}

      {/* Card de Produto Simulado */}
      <Box mt={2} p={2} style={{ backgroundColor: cardColor, borderRadius: 10, border: '1px solid rgba(0, 0, 0, 0.06)' }}>
        <Typography variant="caption" style={{ color: textColor, opacity: 0.6, fontSize: 11, display: 'block', marginBottom: 4 }}>
          Exemplo de Card de Produto
        </Typography>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <div>
            <Typography variant="body2" style={{ fontWeight: 700, color: textColor }}>
              Produto Exemplo
            </Typography>
            <Typography variant="subtitle2" style={{ color: supportColor, fontWeight: 800 }}>
              R$ 99,90
            </Typography>
          </div>
          <Button
            size="small"
            variant="contained"
            disableElevation
            style={{
              backgroundColor: primaryColor,
              color: '#fff',
              borderRadius: 8,
              textTransform: 'none',
              fontSize: 12,
              fontWeight: 600,
              padding: '6px 14px',
            }}
          >
            Adicionar
          </Button>
        </Box>
      </Box>

      {/* Rodapé Simulado */}
      <Box mt={2} pt={2} style={{ borderTop: '1px solid rgba(148, 163, 184, 0.2)', textAlign: 'center' }}>
        <Typography variant="caption" display="block" style={{ fontWeight: 700, color: textColor }}>
          {companyPseudonym}
        </Typography>
        <Typography variant="caption" display="block" style={{ color: textColor, opacity: 0.6, fontSize: 10, marginTop: 2 }}>
          {companyName ? `Razão Social: ${companyName}` : ''} {companyCNPJ ? `• CNPJ: ${companyCNPJ}` : ''}
        </Typography>
        {(phone || email) && (
          <Typography variant="caption" display="block" style={{ color: textColor, opacity: 0.6, fontSize: 10, marginTop: 2 }}>
            {phone ? `Tel: ${phone}` : ''} {email ? `• ${email}` : ''}
          </Typography>
        )}
      </Box>
    </Paper>
  );

  if (!isAdmin) {
    return <AccessRestricted requiredLevel="Administrador" />;
  }

  if (loadSettingsInfo.loading) {
    return (
      <PageContent>
        <UIContainer container direction="column" alignItems="center" justify="center" style={{ padding: '80px 0' }}>
          <CircularProgress color="primary" />
        </UIContainer>
      </PageContent>
    );
  }

  if (loadSettingsInfo.error) {
    const apiError = loadSettingsInfo.error?.response?.data?.error || '';
    const isAddonInactive =
      apiError.toLowerCase().includes('add-on') ||
      apiError.toLowerCase().includes('addon') ||
      apiError.toLowerCase().includes('catálogo não encontrado') ||
      loadSettingsInfo.error?.response?.status === 401 ||
      loadSettingsInfo.error?.response?.status === 404;

    if (isAddonInactive) {
      return (
        <PageContent>
          <UIContainer container direction="column">
            <UIFormTitle title="Catálogo Online & Vitrine Virtual" />

            <Grid container spacing={3} style={{ marginTop: 8 }}>
              <Grid item xs={12} md={7}>
                <Paper
                  elevation={2}
                  style={{
                    padding: isDesktop ? 32 : 20,
                    borderRadius: 16,
                    backgroundColor: '#ffffff',
                    border: '1px solid #e2e8f0',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box>
                    <Box display="flex" alignItems="center" style={{ gap: 8, marginBottom: 16 }}>
                      <Chip
                        label="RECURSO EXCLUSIVO"
                        size="small"
                        style={{
                          backgroundColor: '#eff6ff',
                          color: '#2563eb',
                          fontWeight: 700,
                          fontSize: 11,
                        }}
                      />
                      <Chip
                        label="ZERO TAXAS"
                        size="small"
                        style={{
                          backgroundColor: '#f0fdf4',
                          color: '#16a34a',
                          fontWeight: 700,
                          fontSize: 11,
                        }}
                      />
                    </Box>

                    <Typography variant="h5" style={{ fontWeight: 800, color: '#0f172a', marginBottom: 12 }}>
                      Ative seu Catálogo Digital & Venda Mais no WhatsApp!
                    </Typography>

                    <Typography variant="body1" style={{ color: '#475569', lineHeight: 1.6, marginBottom: 20 }}>
                      Tenha seu próprio site de vendas sincronizado em tempo real com seu estoque, controle financeiro e preços. Seus clientes montam o carrinho e enviam o pedido formatado direto no WhatsApp da sua empresa, sem intermediários e sem taxas por venda.
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </UIContainer>
        </PageContent>
      );
    }
  }

  return (
    <PageContent>
      <UIContainer container direction="column">
        <UIFormTitle title="Catálogo" />

        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          {/* Top Status & Main Action Bar */}
          <Paper
            elevation={1}
            style={{
              padding: isDesktop ? '18px 24px' : '16px',
              borderRadius: 14,
              backgroundColor: '#ffffff',
              border: '1px solid #e2e8f0',
              marginBottom: 20,
            }}
          >
            <Grid container alignItems="center" justify="space-between" spacing={2}>
              <Grid item xs={12} md={7}>
                <Box display="flex" alignItems="center" style={{ gap: 14 }}>
                  <div
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: 10,
                      backgroundColor: '#2563eb',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                      flexShrink: 0,
                    }}
                  >
                    <StorefrontIcon />
                  </div>
                  <div>
                    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                      <Typography variant="h6" style={{ fontWeight: 800, color: '#0f172a', fontSize: '1.1rem' }}>
                        Status do Catálogo
                      </Typography>
                      <Chip
                        label={catalogEnabled ? 'ATIVO' : 'DESATIVADO'}
                        size="small"
                        style={{
                          backgroundColor: catalogEnabled ? '#dcfce7' : '#fee2e2',
                          color: catalogEnabled ? '#15803d' : '#b91c1c',
                          fontWeight: 700,
                          fontSize: 11,
                        }}
                      />
                    </Box>
                    <Typography variant="body2" style={{ color: '#475569', marginTop: 2 }}>
                      Link oficial:{' '}
                      <a
                        href={storeUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#2563eb', fontWeight: 700, textDecoration: 'none' }}
                      >
                        {storeUrl}
                      </a>
                    </Typography>
                  </div>
                </Box>
              </Grid>

              <Grid item xs={12} md={5}>
                <Box display="flex" alignItems="center" justifyContent={{ xs: 'space-between', md: 'flex-end' }} flexWrap="wrap" style={{ gap: 12 }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={catalogEnabled}
                        onChange={(e) => setCatalogEnabled(e.target.checked)}
                        color="primary"
                      />
                    }
                    label={<Typography variant="body2" style={{ fontWeight: 600, color: '#334155' }}>Catálogo Visível</Typography>}
                  />

                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="medium"
                    disableElevation
                    disabled={saveSettingsInfo.loading}
                    startIcon={saveSettingsInfo.loading ? <CircularProgress size={18} color="inherit" /> : <SaveIcon />}
                    style={{
                      borderRadius: 10,
                      padding: '8px 24px',
                      fontWeight: 700,
                      textTransform: 'none',
                    }}
                  >
                    Salvar Alterações
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Paper>

          {/* Toggle de Preview para Mobile */}
          {!isDesktop && (
            <Box mb={2}>
              <Button
                fullWidth
                variant="outlined"
                onClick={() => setMobilePreviewOpen(!mobilePreviewOpen)}
                startIcon={mobilePreviewOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                style={{
                  textTransform: 'none',
                  borderRadius: 10,
                  borderColor: '#2563eb',
                  color: '#2563eb',
                  fontWeight: 700,
                  backgroundColor: '#eff6ff',
                  padding: '10px 16px',
                }}
              >
                {mobilePreviewOpen ? 'Ocultar Pré-visualização' : 'Ver Pré-visualização da Loja'}
              </Button>
              <Collapse in={mobilePreviewOpen}>
                <Box mt={2}>
                  {renderPreview()}
                </Box>
              </Collapse>
            </Box>
          )}

          <Grid container spacing={3}>
            {/* Left Column: Form Settings */}
            <Grid item xs={12} md={7}>
              <Paper elevation={2} style={{ padding: isDesktop ? 24 : 16, borderRadius: 14 }}>
                {/* Seção 1: Link & Compartilhamento */}
                {renderSectionHeader(LinkIcon, 'Link da Loja', 'Endereço exclusivo para divulgação')}
                <Box mb={2.5}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    placeholder="minha-loja"
                    value={catalogSlug}
                    onChange={(e) => {
                      const clean = e.target.value.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
                      setCatalogSlug(clean);
                    }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">.duzz.store</InputAdornment>,
                    }}
                  />
                  <Box display="flex" flexWrap="wrap" gridGap={8} mt={1}>
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<FileCopyIcon style={{ fontSize: 16 }} />}
                      onClick={handleCopyLink}
                      style={{
                        textTransform: 'none',
                        borderRadius: 8,
                        borderColor: '#cbd5e1',
                        color: '#334155',
                        fontWeight: 600,
                        fontSize: 12,
                      }}
                    >
                      Copiar Link
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<WhatsAppIcon style={{ fontSize: 16 }} />}
                      onClick={handleCopyWhatsAppMsg}
                      style={{
                        textTransform: 'none',
                        borderRadius: 8,
                        borderColor: '#22c55e',
                        color: '#15803d',
                        backgroundColor: '#f0fdf4',
                        fontWeight: 600,
                        fontSize: 12,
                      }}
                    >
                      Copiar Mensagem WhatsApp
                    </Button>
                  </Box>
                </Box>

                <Divider style={{ margin: '20px 0' }} />

                {/* Seção 2: Textos da Vitrine */}
                {renderSectionHeader(TextFieldsIcon, 'Frases & Textos', 'Subtítulo e mensagem de boas-vindas')}
                <Grid container spacing={2} style={{ marginBottom: 12 }}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      label="Subtítulo do Cabeçalho"
                      placeholder="Ex: Catálogo Oficial, Moda Feminina, Pizzaria..."
                      value={catalogSubtitle}
                      onChange={(e) => setCatalogSubtitle(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      label="Mensagem do Banner"
                      placeholder="Ex: Explore nossos produtos e faça seu pedido pelo WhatsApp."
                      value={heroSubtitle}
                      onChange={(e) => setHeroSubtitle(e.target.value)}
                    />
                  </Grid>
                </Grid>

                <Divider style={{ margin: '24px 0' }} />

                {/* Seção 3: Redes Sociais & Contatos */}
                {renderSectionHeader(ShareIcon, 'Contatos & Redes Sociais', 'Canais de atendimento ao cliente')}
                <Grid container spacing={2} style={{ marginBottom: 12 }}>
                  <Grid item xs={12} sm={6}>
                    <InputMask
                      value={whatsapp}
                      mask={whatsapp.replace(/\D/g, '').length > 10 ? '(99) 99999-9999' : '(99) 9999-9999'}
                      maskChar={null}
                      onChange={(e) => setWhatsapp(e.target.value)}
                    >
                      {() => (
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          label="WhatsApp de Pedidos *"
                          placeholder="(00) 00000-0000"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <WhatsAppIcon style={{ color: '#25d366', fontSize: 18 }} />
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    </InputMask>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      label="Instagram"
                      placeholder="nomedaloja"
                      value={instagram}
                      onChange={(e) => setInstagram(cleanInstagramHandle(e.target.value))}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <span style={{ fontWeight: 700, color: '#e1306c', fontSize: 15 }}>@</span>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputMask
                      value={phone}
                      mask={phone.replace(/\D/g, '').length > 10 ? '(99) 99999-9999' : '(99) 9999-9999'}
                      maskChar={null}
                      onChange={(e) => setPhone(e.target.value)}
                    >
                      {() => (
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          label="Telefone Adicional"
                          placeholder="(00) 0000-0000"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PhoneIcon style={{ color: '#64748b', fontSize: 18 }} />
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    </InputMask>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      label="E-mail de Contato"
                      placeholder="Ex: contato@sualoja.com.br"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      label="Endereço / Localização"
                      placeholder="Ex: Rua das Flores, 123 - Centro (ou link do Maps)"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LocationOnIcon style={{ color: '#ef4444', fontSize: 18 }} />
                          </InputAdornment>
                        ),
                        endAdornment: address && address.trim() ? (
                          <InputAdornment position="end">
                            <Tooltip title="Abrir no Google Maps">
                              <IconButton
                                size="small"
                                component="a"
                                target="_blank"
                                rel="noopener noreferrer"
                                href={
                                  address.trim().startsWith('http://') || address.trim().startsWith('https://')
                                    ? address.trim()
                                    : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address.trim())}`
                                }
                                style={{ color: '#2563eb', padding: 4 }}
                              >
                                <OpenInNewIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </InputAdornment>
                        ) : null,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      label="Horário de Atendimento"
                      placeholder="Ex: Seg a Sex: 08h às 18h | Sáb: 08h às 12h"
                      value={businessHours}
                      onChange={(e) => setBusinessHours(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      label="Facebook"
                      placeholder="Ex: facebook.com/sualoja"
                      value={facebook}
                      onChange={(e) => setFacebook(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      label="TikTok"
                      placeholder="Ex: @sualoja"
                      value={tiktok}
                      onChange={(e) => setTiktok(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      label="Website"
                      placeholder="Ex: https://sualoja.com.br"
                      value={website}
                      onChange={(e) => setWebsite(e.target.value)}
                    />
                  </Grid>
                </Grid>

                <Divider style={{ margin: '24px 0' }} />

                {/* Seção 4: Temas Rápidos */}
                {renderSectionHeader(ColorLensIcon, 'Cores & Temas', 'Personalize as cores da vitrine')}

                {/* duxIA Smart Palette Suggestion Card */}
                <Box
                  mb={2.5}
                  p={2}
                  style={{
                    backgroundColor: '#f8fafc',
                    border: '1px solid #e2e8f0',
                    borderRadius: 12,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 12,
                  }}
                >
                  <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                    <Box
                      style={{
                        width: 38,
                        height: 38,
                        borderRadius: 8,
                        backgroundColor: '#eff6ff',
                        border: '1px solid #dbeafe',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#2563eb',
                        flexShrink: 0,
                      }}
                    >
                      <AssistantIcon style={{ fontSize: 22 }} />
                    </Box>
                    <Box>
                      <Box display="flex" alignItems="center" style={{ gap: 6 }}>
                        <Typography variant="subtitle2" style={{ fontWeight: 700, color: '#0f172a' }}>
                          Sugerir Cores com duxIA
                        </Typography>
                        <Chip
                          label="IA"
                          size="small"
                          style={{
                            backgroundColor: '#eff6ff',
                            color: '#2563eb',
                            fontWeight: 800,
                            fontSize: 10,
                            height: 18,
                          }}
                        />
                      </Box>
                      <Typography variant="caption" style={{ color: '#64748b', display: 'block' }}>
                        Analisa a logo e o banner da sua loja para calibrar a paleta visual ideal.
                      </Typography>
                    </Box>
                  </Box>

                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={handleSuggestPaletteWithAI}
                    disabled={generateBrandPaletteInfo.loading}
                    startIcon={
                      generateBrandPaletteInfo.loading ? (
                        <CircularProgress size={14} color="inherit" />
                      ) : (
                        <AssistantIcon style={{ fontSize: 16 }} />
                      )
                    }
                    style={{
                      textTransform: 'none',
                      fontWeight: 700,
                      borderRadius: 8,
                      padding: '6px 14px',
                      borderColor: '#2563eb',
                      color: '#2563eb',
                      backgroundColor: '#ffffff',
                    }}
                  >
                    {generateBrandPaletteInfo.loading ? 'Analisando...' : 'Sugerir com duxIA ✨'}
                  </Button>
                </Box>

                <Typography variant="caption" style={{ fontWeight: 700, color: '#475569', display: 'block', marginBottom: 10 }}>
                  Temas Rápidos Pré-configurados:
                </Typography>

                <Grid container spacing={1.5} style={{ marginBottom: 20 }}>
                  {THEME_PRESETS.map((preset, idx) => {
                    const active = isPresetActive(preset);
                    return (
                      <Grid item xs={6} sm={4} key={idx}>
                        <Box
                          onClick={() => applyPreset(preset)}
                          style={{
                            cursor: 'pointer',
                            padding: '10px 12px',
                            borderRadius: 10,
                            border: `2px solid ${active ? '#2563eb' : '#e2e8f0'}`,
                            backgroundColor: active ? '#eff6ff' : '#ffffff',
                            transition: 'all 0.2s ease',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            boxShadow: active ? '0 4px 12px rgba(37, 99, 235, 0.12)' : 'none',
                          }}
                        >
                          <Box
                            style={{
                              display: 'flex',
                              gap: 3,
                              padding: 3,
                              borderRadius: 6,
                              backgroundColor: preset.bg,
                              border: '1px solid #cbd5e1',
                              flexShrink: 0,
                            }}
                          >
                            <span style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: preset.primary, display: 'block' }} />
                            <span style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: preset.card, display: 'block' }} />
                          </Box>
                          <Typography
                            variant="caption"
                            noWrap
                            style={{
                              fontWeight: active ? 700 : 600,
                              color: active ? '#2563eb' : '#334155',
                              fontSize: 12,
                            }}
                          >
                            {preset.name}
                          </Typography>
                          {active && (
                            <CheckCircleIcon style={{ fontSize: 16, color: '#2563eb', marginLeft: 'auto', flexShrink: 0 }} />
                          )}
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>

                {/* Sub-grupo 1: Estrutura da Loja */}
                <Typography variant="caption" style={{ fontWeight: 700, color: '#475569', display: 'block', marginBottom: 10, marginTop: 10 }}>
                  Estrutura & Fundo da Loja:
                </Typography>
                <Grid container spacing={1.5} style={{ marginBottom: 20 }}>
                  <Grid item xs={12} sm={4}>
                    {renderColorPickerItem('Fundo da Loja', backgroundColor, setBackgroundColor)}
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    {renderColorPickerItem('Superfície / Cards', cardColor, setCardColor)}
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    {renderColorPickerItem('Textos Gerais', textColor, setTextColor)}
                  </Grid>
                </Grid>

                {/* Sub-grupo 2: Identidade da Marca */}
                <Typography variant="caption" style={{ fontWeight: 700, color: '#475569', display: 'block', marginBottom: 10 }}>
                  Identidade & Destaques da Marca:
                </Typography>
                <Grid container spacing={1.5} style={{ marginBottom: 20 }}>
                  <Grid item xs={12} sm={4}>
                    {renderColorPickerItem('Cor Primária', primaryColor, setPrimaryColor)}
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    {renderColorPickerItem('Cor Secundária', secondaryColor, setSecondaryColor)}
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    {renderColorPickerItem('Cor de Suporte', supportColor, setSupportColor)}
                  </Grid>
                </Grid>

                <Divider style={{ margin: '24px 0' }} />

                {/* Seção 5: Logo & Banner */}
                {renderSectionHeader(ImageIcon, 'Identidade Visual', 'Logotipo e banner da vitrine')}
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <UIImageUpload
                      id="catalog-logo-upload"
                      label="Logotipo da Loja"
                      helperText="Recomendado: 400x400 px (1:1 quadrada) PNG transparente."
                      value={logoUrl}
                      onChange={(url) => setLogoUrl(url || '')}
                      maxImages={1}
                      hideSuggestions
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <UIImageUpload
                      id="catalog-banner-upload"
                      label="Banner Panorâmico"
                      helperText="Recomendado: 1200x400 px (3:1 panorâmico) JPG ou PNG."
                      value={bannerUrl}
                      onChange={(url) => setBannerUrl(url || '')}
                      maxImages={1}
                      hideSuggestions
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {/* Right Column: Sticky Live Preview on Desktop */}
            {isDesktop && (
              <Grid item xs={12} md={5}>
                <Box style={{ position: 'sticky', top: 24 }}>
                  {renderPreview()}
                </Box>
              </Grid>
            )}
          </Grid>
        </form>

        <Snackbar
          open={toast.open}
          autoHideDuration={4000}
          onClose={() => setToast({ ...toast, open: false })}
        >
          <Alert onClose={() => setToast({ ...toast, open: false })} severity={toast.severity}>
            {toast.message}
          </Alert>
        </Snackbar>
      </UIContainer>
    </PageContent>
  );
};

export default ConfiguracaoCatalogo;
